module.exports = __webpack_public_path__ + "static/img/4.fcd39d91.png";